import type { ReactNode } from "react";
import "./AlertsGroupTitle.scss";
import type { ScheduleAlertLevel } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlertLevel.ts";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

interface Properties {
  level: ScheduleAlertLevel;
  count: number;
}

export default function AlertsGroupTitle(props: Properties): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement.scheduleAlerts.alertsGroupTitle",
  });
  const levelLowerCase = props.level.toLowerCase();

  return (
    <div className={classNames("alerts-group-title", levelLowerCase)}>
      <div className="icon" />
      <div className="text">{t(levelLowerCase, { count: props.count })}</div>
    </div>
  );
}
